var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"\n    absolute\n    bg-sky\n    font-bold\n    flex\n    z-999\n    w-full\n    h-full\n    items-center\n    justify-center\n  "},[_vm._v(" Please rotate device ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }